<template>
  <draggable-dialog
      :visible="props.visible"
      :title="title"
      :modal-class="isMin ? 'wps-view-dialog-xxt-v2 min-size' : 'wps-view-dialog-xxt-v2'"
      :model-value="props.visible"
      top="6vh"
      :draggable="!isMin"
      :modal="false"
      destroy-on-close
      :show-close="false"
      :close-on-click-modal="false"
      :fullscreen="isFull"
      @open="onOpen"
      @closed="closedModal"
      @update:visible="val => emit('update:visible', val)"
  >

    <template #header>
      <div class="header">
        <h4>{{ props.title }}</h4>
        <div class="right-opera">
          <el-icon
              v-if="!isMin"
              title="最小化"
              style="opacity: 0.6;position: relative;top: 4px;"
              @click="exeMinDialog">
            <SemiSelect/>
          </el-icon>

          <el-icon
              v-if="isMin"
              title="还原"
              style="opacity: 0.9;position: relative;top: 3px;"
              @click="exeRestoreDialog">
            <TopRight/>
          </el-icon>

          <el-icon
              v-if="!isFull && !isMin"
              title="全屏"
              @click="isFull = true"
          >
            <FullScreen/>
          </el-icon>

          <el-icon
              v-if="isFull && !isMin"
              title="还原"
              style="opacity: 0.9;position: relative;top: 1px;"
              @click="isFull = false">
            <RefreshLeft/>
          </el-icon>

          <el-icon
              class="my-close"
              @click="emit('update:visible', false)">
            <Close/>
          </el-icon>
        </div>
      </div>
    </template>

    <template #default>
      <div style="height: 100%;">
        <div
            class="content"
            :class="{'full-wps': isFull}"
        >
          <free-view-office
              :oss-path="props.ossPath"
              :office-type="officeType"
          />
        </div>
      </div>
    </template>
  </draggable-dialog>
</template>

<script setup>
/*
 * 支持拖拽的V2版本在线资料弹层
 */
import DraggableDialog from "./draggableDialog.vue";
import FreeViewOffice from "@/components/OnlineWps/freeViewOffice.vue";
import {$emit, $off, $on} from "vue-happy-bus";
import {calcMinDialogLeft} from "@/components/TxPlayer/minDialogCompute.js";

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  ossPath: {
    type: String,
    default: ''
  },
  officeType:{
    type: String,
    default: WebOfficeSDK.OfficeType.Spreadsheet
  },
  title: {
    type: String,
    default: '弹层'
  }
})

const isFull = ref(false)
const selfId = 'onlinePreviewDialog'

function onOpen() {
  $on('dialogChange', id => {
    if (isMin.value && id != selfId) {
      calcMinDialogLeft('wps-view-dialog-xxt-v2', 'video-dialog-txy-765')
    }
  })
}

const emit = defineEmits(['update:visible'])

function closedModal() {
  emit('update:visible', false)
  $emit('dialogChange', selfId)
  $off('dialogChange')
  isFull.value = false
  isMin.value = false
}

const isMin = ref(false) // 是否最小化了

// 执行最小化
function exeMinDialog() {
  isMin.value = true
  calcMinDialogLeft('wps-view-dialog-xxt-v2', 'video-dialog-txy-765')
}

function exeRestoreDialog() {
  isMin.value = false
  $emit('dialogChange', selfId)
}
</script>

<style lang="scss">
.wps-view-dialog-xxt-v2 {
  pointer-events: none;

  .el-dialog {
    pointer-events: auto;

    .header {
      display: flex;
      justify-content: space-between;
      align-content: center;

      > h4 {
        font-size: 18px;
        line-height: 24px;
      }

      .right-opera {
        cursor: pointer;

        .el-icon {
          font-size: 18px;
          margin-left: 15px;

          &:hover {
            color: var(--el-color-primary);
          }

          &:first-child {
            margin-left: 0;
          }
        }
      }
    }

    .content {
      height: 100%;

      &.full-wps {
        height: calc(100vh - 80px);
      }
    }

    &.is-fullscreen { // 全屏支持属性
      left: unset !important;
      top: unset !important;
      width: unset !important;
      height: 100% !important;
      margin: unset !important;
      position: unset !important;
    }
  }

  &.min-size {
    .el-dialog {
      transform: initial !important;
      --el-dialog-width: 180px !important;
      margin-top: calc(100vh - 56px) !important;
      margin-left: 0 !important;

      position: unset !important;
      left: unset !important;
      width: 200px !important;
      top: unset !important;

      .el-dialog__header {
        padding-bottom: 0;
        .my-close {
          position: relative;
          top: 2px;
        }
      }

      .el-dialog__body {
        visibility: hidden;
        height: 0;
        overflow: hidden;
      }
    }
  }
}
</style>
